import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter, Switch } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { IntlProvider } from 'react-intl';

import Routes from './Routes';
import CommonReference from './components/CommonReference';
import enMessages from './locale/en-us';
import initAdapter, { parseInitBuffer } from './utilities/initAdapter';

import './index.css';
import './css/common.sass';

// #2598: Refactor to functional component to use initAdapter values (2023-MAR)
const App = () => {
  const funlidayEnv = document.querySelector('meta[name="funliday-env"]');
  console.log('call method parseInitBuffer');
  parseInitBuffer(funlidayEnv.content);

  const locale = initAdapter.locale;
  const [messages, setMessages] = useState('');

  const importLocaleData = () => {
    Promise.all([
      import(
        // source http://www.reactpeixun.com/reactganhuo/2017-04-21/297.html
        // polyfill
        // import(`intl/locale-data/jsonp/${locale}`),
        // import locale data
        // `react-intl/locale-data/${locale}`
        `@formatjs/intl-pluralrules/dist/locale-data/${locale.split(/[-_]/)[0]}`
      ), // import message data
      import(`./locale/${locale}`)
    ])
      .then(values => {
        // react-intl : add locale data
        // addLocaleData([...values[0]]);
        // set state and re-render
        setMessages(values[1].default);
      })
      .catch(err => {
        // console.log('importLocaleData err = ', err);
      });
  };

  const renderComponent = (targetLocale, translations) => (
    // set default locale and messages to en
    <IntlProvider locale={targetLocale} messages={translations}>
      <BrowserRouter>
        <Switch>{renderRoutes(Routes)}</Switch>
      </BrowserRouter>
      <CommonReference />
    </IntlProvider>
  );

  if (messages) {
    return renderComponent(locale, messages);
  }
  importLocaleData();
  // fallback
  return renderComponent(locale, enMessages);
};

App.defaultProps = {
  locale: 'en'
};

App.propTypes = {
  locale: PropTypes.string
};

const mapStateToProps = state => ({
  locale: state.internationalize.locale
});

export default connect(mapStateToProps, null)(App);
